import { useCallback, useMemo } from "react";

import { Funnel } from "components/icons/generated";
import { CallbackTrack } from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";
import { ApplyFiltersContext } from "components/Filters";
import { FiltersDictionary } from "components/Filters/types";

import { TableCellAction } from "../Row/CellContent";

type MakeUseCellFilterActionProps = {
  title?: string;
  trackAnalytics?: CallbackTrack;
  searchSuggestionsDictionary: FiltersDictionary;
};

export type UseCellFilterActionProps = {
  filterName: string;
  filterValue: string;
  spaceCell?: boolean;
};

const makeUseCellFilterAction = ({
  title = "Add to filters",
  trackAnalytics,
  searchSuggestionsDictionary,
}: MakeUseCellFilterActionProps) => {
  const useCellFilterAction = ({
    filterName,
    filterValue,
    spaceCell,
  }: UseCellFilterActionProps): TableCellAction => {
    const { applyFilter, applySpaceFilter } = useTypedContext(ApplyFiltersContext);

    const filterAction = spaceCell ? applySpaceFilter : applyFilter;

    const action = useCallback(() => {
      filterAction(filterName, searchSuggestionsDictionary)(filterValue);
      trackAnalytics?.("Add to filters clicked", { type: filterName });
    }, [filterAction, filterName, filterValue]);

    return useMemo(
      () => ({
        icon: Funnel,
        title,
        onPress: action,
      }),
      [action]
    );
  };

  return useCellFilterAction;
};

export default makeUseCellFilterAction;
